import { render, staticRenderFns } from "./StartUpPackage.vue?vue&type=template&id=6846215e&"
import script from "./StartUpPackage.vue?vue&type=script&lang=js&"
export * from "./StartUpPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports